import { QueryClient } from '@tanstack/react-query';

import { ApiError } from './error';

// 4xx answers are deterministic (permission, scope, validation): retrying
// only delays the error state the user needs to see.
function shouldRetryQuery(failureCount, error) {
    if (error instanceof ApiError && error.isClientError) return false;
    return failureCount < 1;
}

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            retry: shouldRetryQuery,
            refetchOnWindowFocus: true,
            refetchOnReconnect: true,
        },
        mutations: {
            retry: 0,
        },
    },
});
